// ===============================================================
// KOÇUM ONLINE AI - GEMINI ENTEGRASYON SERVİSİ
// ===============================================================

export const GEMINI_API_KEY = "AQ.Ab8RN6J3UoFlcOVChxQKWWT31CgQhIAk9xdGCrqVmKglSKNQxQ";

// Model önceliği: En hızlı ve hafif model birincil, alternatif yedek
const PRIMARY_MODEL = "gemini-3.5-flash-lite";
const FALLBACK_MODEL = "gemini-3.5-flash";

/**
 * Öğrencinin sistemdeki mevcut tüm gerçek verilerini (denemeler,
 * güncel haftalık program, arşivlenmiş haftalar, rutinler, hedefler)
 * AI için net ve özet bir bağlam (context) haline getirir.
 */
export function buildStudentContextSummary(student, curriculum = []) {
  if (!student) return "Kayıtlı öğrenci verisi bulunamadı.";

  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  // 1. Güncel Program (assignments) İncelemesi
  const assignments = Array.isArray(student.assignments) ? student.assignments : [];
  let currentWeekTotalTasks = assignments.length;
  let currentWeekCompletedTasks = 0;
  let currentWeekTargetQuestions = 0;
  let currentWeekSolvedQuestions = 0;

  assignments.forEach(task => {
    const targetCount = parseInt(task.count, 10) || 0;
    const solvedCount = parseInt(task.solvedCount, 10) || (task.status === 'completed' ? targetCount : 0);
    currentWeekTargetQuestions += targetCount;
    currentWeekSolvedQuestions += solvedCount;
    if (task.status === 'completed') currentWeekCompletedTasks++;
  });

  // 2. Arşivlenmiş Geçmiş Haftalar (pastWeeks)
  const pastWeeks = Array.isArray(student.pastWeeks) ? student.pastWeeks : [];
  let pastWeeksTotalSolved = 0;
  let thisMonthArchivedSolved = 0;
  const recentPastWeeksSummary = [];

  pastWeeks.forEach(w => {
    const solved = parseInt(w.solvedCount, 10) || 0;
    pastWeeksTotalSolved += solved;

    // Tarih kontrolü
    let wDate = null;
    if (w.date) {
      if (typeof w.date === 'string' && w.date.includes('.')) {
        const parts = w.date.split('.');
        if (parts.length === 3) wDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
      } else {
        wDate = new Date(w.date);
      }
    }

    if (wDate && !isNaN(wDate.getTime())) {
      if (wDate.getMonth() === currentMonth && wDate.getFullYear() === currentYear) {
        thisMonthArchivedSolved += solved;
      }
    }

    recentPastWeeksSummary.push({
      name: w.name || 'Hafta',
      date: w.date || 'Tarihsiz',
      solved: solved
    });
  });

  // Bu ay toplam çözülen soru (güncel hafta + arşiv)
  const thisMonthTotalSolved = thisMonthArchivedSolved + currentWeekSolvedQuestions;
  const allTimeProgramSolved = pastWeeksTotalSolved + currentWeekSolvedQuestions;

  // 3. Denemeler
  const exams = Array.isArray(student.exams) ? student.exams : [];
  const sortedExams = [...exams].sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));
  const recentExams = sortedExams.slice(0, 5).map(e => ({
    name: e.name || 'Deneme',
    type: e.type || 'Genel',
    date: e.date || '',
    totalNet: e.totalNet ?? 'Belirtilmemiş',
    subjects: Array.isArray(e.subjects) ? e.subjects.map(s => `${s.name}: ${s.net} net`).join(', ') : ''
  }));

  // 4. Rutinler (Paragraf, Problem, Kitap)
  const routines = Array.isArray(student.routines) ? student.routines : [];
  let paragrafThisMonth = 0;
  let problemThisMonth = 0;
  let kitapThisMonthPages = 0;

  routines.forEach(r => {
    let rDate = r.date ? new Date(r.date) : null;
    const isThisMonth = rDate && !isNaN(rDate.getTime()) ? (rDate.getMonth() === currentMonth && rDate.getFullYear() === currentYear) : true;
    const cnt = parseInt(r.count, 10) || 0;

    if (isThisMonth) {
      if (r.type === 'paragraf') paragrafThisMonth += cnt;
      else if (r.type === 'problem') problemThisMonth += cnt;
      else if (r.type === 'kitap') kitapThisMonthPages += cnt;
    }
  });

  // 5. Hedefler
  const goals = Array.isArray(student.goals) ? student.goals : [];
  const activeGoals = goals.map(g => `${g.title || 'Hedef'}: Hedef=${g.target || '-'}, Mevcut=${g.current || '-'} (${g.completed ? 'Tamamlandı' : 'Devam Ediyor'})`);

  // 6. Müfredat Ders Listesi
  const availableCourses = Array.isArray(curriculum) ? curriculum.map(c => c.name).filter(Boolean) : [];

  return `
--- ÖĞRENCİ SİSTEM GERÇEK VERİLERİ (GÜNCEL) ---
Öğrenci Adı: ${student.name || 'Öğrenci'}
Sınıf / Alan: ${student.grade || student.class || 'Belirtilmemiş'} / ${student.field || student.area || 'Genel'}

[SORU VE PROGRAM İSTATİSTİKLERİ]
- Bu Ay Program & Arşivlerden Çözülen Soru Sayısı: ${thisMonthTotalSolved} soru
- Güncel Hafta: Toplam ${currentWeekTotalTasks} görev var, ${currentWeekCompletedTasks} tanesi tamamlandı.
- Güncel Hafta Çözülen Soru: ${currentWeekSolvedQuestions} / ${currentWeekTargetQuestions} hedef
- Arşivlenen Geçmiş Haftalardan Toplam Çözülen: ${pastWeeksTotalSolved} soru
- Tüm Zamanlar Program Soru Toplamı: ${allTimeProgramSolved} soru

[BU AY TAMAMLANAN RUTİNLER]
- Paragraf Rutini: ${paragrafThisMonth} soru
- Problem Rutini: ${problemThisMonth} soru
- Kitap Okuma: ${kitapThisMonthPages} sayfa

[DENEME VERİLERİ VE NETLER]
- Toplam Girilen Deneme: ${exams.length} adet
- Son Girilen Denemeler:
${recentExams.length > 0 ? recentExams.map(e => `  * ${e.date} | ${e.type} - ${e.name} | Toplam Net: ${e.totalNet} ${e.subjects ? `(${e.subjects})` : ''}`).join('\n') : '  * Henüz deneme kaydı girilmemiş.'}

[HAFTALIK HEDEFLER]
${activeGoals.length > 0 ? activeGoals.map(g => `  * ${g}`).join('\n') : '  * Aktif haftalık hedef girilmemiş.'}

[SİSTEMDEKİ DERSLER (MÜFREDAT)]
${availableCourses.length > 0 ? availableCourses.join(', ') : 'Matematik, Geometri, Fizik, Kimya, Biyoloji, Türkçe, Edebiyat, Tarih, Coğrafya, Felsefe'}
------------------------------------------------
`;
}

/**
 * Koçum Online AI için System Prompt
 */
function getSystemPrompt(studentContext) {
  return `Sen "Koçum Online AI" adlı akıllı bir eğitim, soru çözüm ve veri analiz asistanısın.
Kullanıcın bir öğrencidir. Öğrenciye her zaman samimi, motive edici, saygılı ve akademik olarak rehberlik eden bir dille yaklaş.

GÖREVLERİN VE KESİN KURALLARIN:

1. SORU ÇÖZÜM ASİSTANI:
- Öğrenci bir soru metni yazdığında veya sorunun fotoğrafını gönderdiğinde soruyu adım adım, mantığını ve varsa formüllerini tane tane açıklayarak çöz.
- Çözümün anlaşılır, net ve öğretici olmasına özen göster.

2. KAZANIM VE KONU TESPİTİ (ÇOK ÖNEMLİ):
- Öğrenciler deneme sınavı sonrası kazanım analizi yaparken soruların hangi konuya ait olduğunu tespit etmekte zorlanabilir.
- Her soru çözümünde veya soru konusu sorulduğunda MUTLAKA cevabının altında şu formatta net bir kazanım kutusu oluştur:
📌 **Kazanım Analizi:**
- **Ders:** [Örn: Geometri / Fizik / Türkçe / TYT Matematik]
- **Ünite:** [Örn: Üçgenler / Elektrik ve Manyetizma / Cümlede Anlam]
- **Alt Konu / Kazanım:** [Örn: Özel Üçgenler ve Pisagor Bağıntısı / Akım ve Direnç]

3. KESİNLİKLE PROGRAM OLUŞTURMA VE KOÇLUK YAPMA (KATI YASAK):
- ASLA öğrenciye günlük, haftalık veya aylık ders çalışma programı hazırlama!
- "Bana haftalık program yap", "Bugün ne çalışmalıyım?", "Hangi derse kaç saat ayırayım?", "Koçluk yapar mısın?", "Beni yönlendir" gibi talepler geldiğinde KESİNLİKLE reddet ve şu standart cevabı ver:
"Ben soru çözüm asistanı ve veri bilgilendirme yapay zekasıyım. Çalışma programı hazırlama, haftalık planlama ve koçluk talepleriniz için lütfen koçunuz Uzm. Psk. Dan. Hamza Metehan KILIÇ ile iletişime geçiniz."

4. ÖĞRENCİ VERİ VE İSTATİSTİK BİLGİLENDİRMESİ:
- Öğrenci "Bu ay kaç soru çözdüm?", "Genel durumum nasıl?", "Deneme netlerim nasıl gidiyor?", "Rutinlerimde durum ne?" gibi istatistik soruları sorduğunda:
- YALNIZCA aşağıda verilen [ÖĞRENCİ SİSTEM GERÇEK VERİLERİ] bölümündeki somut sayılara ve kayıtlara dayanarak cevap ver.
- Asla tahmini, ezbere veya uydurma veri söyleme. Veri yoksa "Sisteminizde henüz kayıtlı ... verisi bulunmuyor" de.
- Genel durumu sorulduğunda son denemelerin net gidişatını, programdaki çözülen soru oranını ve rutinlerini özetle; ancak yeni program hazırlama talebinde yine Uzm. Psk. Dan. Hamza Metehan KILIÇ'a yönlendir.

5. MATEMATİK VE GEOMETRİ YAZIMI (ÇOK ÖNEMLİ):
- Asla karmaşık LaTeX kodları ($...$, $$, \\widehat, \\circ, \\frac, \\sqrt, \\cdot, \\text{}) KULLANMA!
- Çünkü bu kodlar sohbet balonunda ham yazı olarak görünüp öğrencinin kafasını karıştırır.
- Açılar için doğal Türkçe format kullan: m(ABC) = 15°, m(A) = 150°, ABC açısı gibi.
- Dereceler için doğrudan "°" işaretini kullan (Örn: 15°, 180°, 90°).
- Kenarlar ve uzunluklar için: |AB| = |AC|, [BC] kenarı, hipotenüs = 10 cm gibi yaz.
- Üslü sayılar için: a² + b² = c², x², x³ şeklinde yaz.
- Karekök için: √ simgesini kullan (Örn: √64 = 8).
- Kesirler için: a/b veya 1/2 şeklinde yaz.
- Soru çözümlerini bir öğrencinin defterine yazdığı gibi anlaşılır, temiz ve okunaklı adım adım yaz.

6. FORMAT VE ÜSLUP:
- Türkçe konuş.
- Başlıklar ve önemli adımlar için bold (kalın) ve maddeli listeler kullanarak cevabı göz yormayacak şekilde yapılandır.

${studentContext}
`;
}

/**
 * Gemini API Çağrısı Yapan Fonksiyon
 * @param {Array} chatHistory - [{ role: 'user'|'model', text: string, image?: string, mimeType?: string }]
 * @param {string} studentContext - buildStudentContextSummary çıktısı
 */
export async function sendKoçumAiMessage(chatHistory, studentContext) {
  const systemPrompt = getSystemPrompt(studentContext);

  // Gemini REST API contents formatına dönüştürme
  const contents = chatHistory.map(msg => {
    const parts = [];

    // Görsel varsa ekle
    if (msg.image && msg.mimeType) {
      parts.push({
        inline_data: {
          mime_type: msg.mimeType,
          data: msg.image
        }
      });
    }

    // Metin varsa ekle
    if (msg.text) {
      parts.push({
        text: msg.text
      });
    }

    return {
      role: msg.role === 'assistant' || msg.role === 'model' ? 'model' : 'user',
      parts: parts.length > 0 ? parts : [{ text: "..." }]
    };
  });

  const payload = {
    system_instruction: {
      parts: [{ text: systemPrompt }]
    },
    contents: contents,
    generationConfig: {
      temperature: 0.4,
      maxOutputTokens: 2048
    }
  };

  // Önce birincil modeli dene, hata verirse fallback modele geç
  const tryModel = async (modelName) => {
    const url = `https://generativelanguage.googleapis.com/v1beta/models/${modelName}:generateContent?key=${GEMINI_API_KEY}`;
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      const errJson = await res.json().catch(() => ({}));
      const msg = errJson.error?.message || `HTTP ${res.status}`;
      throw new Error(`Model ${modelName} error: ${msg}`);
    }

    const data = await res.json();
    const candidate = data.candidates?.[0];
    const replyText = candidate?.content?.parts?.[0]?.text;

    if (!replyText) {
      throw new Error("Yapay zekadan geçerli bir yanıt alınamadı.");
    }

    return replyText;
  };

  try {
    return await tryModel(PRIMARY_MODEL);
  } catch (err) {
    console.warn(`Koçum Online AI ${PRIMARY_MODEL} hatası, ${FALLBACK_MODEL} deneniyor...`, err);
    try {
      return await tryModel(FALLBACK_MODEL);
    } catch (fallbackErr) {
      console.error("Koçum Online AI tüm modeller başarısız oldu:", fallbackErr);
      throw fallbackErr;
    }
  }
}

// ===============================================================
// ÖĞRETMEN / EĞİTİM KOÇU AI FONKSİYONLARI
// ===============================================================

/**
 * Öğretmen için Akıllı Rapor (Veli Bülteni, Koçluk Karnesi, Maarif Modeli Analizi) veya Program Önerisi Üretir.
 */
export async function generateTeacherReport({ reportType, student, curriculum = [], customNotes = '', teacherName = 'Uzm. Psk. Dan. Hamza Metehan KILIÇ' }) {
  const studentContext = buildStudentContextSummary(student, curriculum);

  let typeSpecificPrompt = '';
  if (reportType === 'veli_bulteni') {
    typeSpecificPrompt = `
GÖREV: Seçilen öğrenci için resmi, güven veren, yapıcı ve profesyonel bir "HAFTALIK VELİ BİLGİLENDİRME BÜLTENİ" hazırla.
İÇERİK DÜZENİ:
1. Başlık: HAFTALIK ÖĞRENCİ GELİŞİM VE TAKİP BÜLTENİ
2. Giriş: Sayın Velimiz hitabıyla başla; haftalık sürece genel ve sıcak bir bakış sun.
3. Akademik ve Soru Çözüm Performansı: Bu hafta ve bu ay çözülen soru sayılarını, program tamamlama durumunu özetle.
4. Deneme Sınavı Gidişatı: Son deneme netlerini, yükseliş gösteren dersleri ve üzerinde durulması gereken noktaları yapıcı bir dille aktar.
5. Rutinler ve Alışkanlıklar: Paragraf, problem ve kitap okuma rutinlerindeki disiplini belirt.
6. Aileye Ev Ortamı İçin Pedagojik Tavsiye: Sınav kaygısını azaltıcı, motivasyon artırıcı 1-2 somut öneri.
7. Kapanış ve İmza: "${teacherName} & Koçum Online Eğitim Danışmanlığı"
`;
  } else if (reportType === 'kocluk_karnesi') {
    typeSpecificPrompt = `
GÖREV: Öğrencinin kendisine yönelik doğrudan hedef odaklı, motive eden ve stratejik bir "BİREYSEL KOÇLUK KARNESİ" hazırla.
İÇERİK DÜZENİ:
1. Başlık: BİREYSEL KOÇLUK VE PERFORMANS KARNESİ
2. Genel Durum Değerlendirmesi: Öğrencinin mevcut çalışma temposunun analizi.
3. Güçlü Yönler: Başarılı olduğu dersler, düzenli yürüttüğü rutinler.
4. Kritik Gelişim Alanları (Eksikler): Net artışı için acil odaklanılması gereken 2-3 ders veya konu.
5. Önümüzdeki Hafta İçin 3 Kritik Eylem Hedefi: Öğrencinin bu hafta mutlaka tamamlaması gereken somut hedefler.
6. Koçluk Notu ve Motivasyon Cümlesi.
`;
  } else if (reportType === 'pedagojik_analiz') {
    typeSpecificPrompt = `
GÖREV: Doğrudan öğretmenin/koçun kendi incelemesi için "TÜRKİYE YÜZYILI MAARİF MODELİ VE PEDAGOJİK GELİŞİM ANALİZİ" hazırla.
İÇERİK DÜZENİ:
1. Başlık: PEDAGOJİK GELİŞİM VE MAARİF MODELİ ANALİZ RAPORU (ÖĞRETMEN NOTU)
2. Beceri Temelli ve Kavramsal Düşünme Değerlendirmesi: Öğrencinin yeni nesil sorulara yaklaşımı, analiz ve muhakeme becerileri.
3. Öz Düzenleme ve Sorumluluk Eğilimleri: Rutin takibi, çalışma sayacı verileri ve erteleme alışkanlığının pedagojik yorumu.
4. Psikolojik Durum ve Sınav Kaygısı Tespiti: Öğrencinin duygudurum veya deneme iniş çıkışlarının analizi.
5. Koç İçin 3 Somut Müdahale Önerisi: Öğretmenin görüşmede öğrenciye uygulayabileceği somut koçluk teknikleri (örn: turlama taktiği, sözel analiz, blok yönetimi).
`;
  } else if (reportType === 'haftalik_program') {
    typeSpecificPrompt = `
GÖREV: Öğrencinin son deneme sınavlarındaki zayıf derslerine, haftalık eksiklerine ve sınıf düzeyine göre somut bir "HAFTALIK DERS ÇALIŞMA PROGRAMI VE ÖDEV TASLAĞI" hazırla.
İÇERİK DÜZENİ:
1. Başlık: KİŞİSELLEŞTİRİLMİŞ HAFTALIK ÇALIŞMA PROGRAMI TASLAĞI
2. Stratejik Odak: Bu haftanın ana tema dersleri ve hedef net artış konuları.
3. Gün Gün Program (Pazartesi'den Pazar'a):
   - Her gün için: Sabah/Öğle/Akşam dersleri, önerilen konu başlıkları, hedef soru sayıları ve kaynak önerisi (örn: 3D, Bilgi Sarmal, Orijinal vb.).
   - Rutinler: Paragraf ve problem hedefleri.
4. Pazar Günü: Haftalık deneme veya genel tekrar bloğu.
5. Toplam Haftalık Soru Hedefi Özeti.
`;
  }

  const prompt = `
Sen "Koçum Online AI Eğitim Danışmanı ve Koçluk Asistanı"sın.
Türkiye Yüzyılı Maarif Modeli'ne (beceri temelli öğrenme, kavramsal beceriler, eğilimler, süreç odaklı değerlendirme), ÖSYM/MEB müfredatına ve öğrenci psikolojisine son derece hakim bir uzmansın.
Raporlarında akademik, saygın, veri odaklı ve çözüm üreten bir üslup kullan.
Asla karmaşık LaTeX sembolleri ($...$, \\widehat, \\circ vb.) kullanma. Doğal Türkçe ve temiz Markdown kullan.

${typeSpecificPrompt}

${customNotes ? `[ÖĞRETMENİN ÖZEL NOTU VE DİKKAT ÇEKTİĞİ HUSUSLAR]:\n${customNotes}\n` : ''}

${studentContext}
`;

  const payload = {
    contents: [
      {
        role: "user",
        parts: [{ text: prompt }]
      }
    ],
    generationConfig: {
      temperature: 0.5,
      maxOutputTokens: 2500
    }
  };

  const tryModel = async (modelName) => {
    const url = `https://generativelanguage.googleapis.com/v1beta/models/${modelName}:generateContent?key=${GEMINI_API_KEY}`;
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      const errJson = await res.json().catch(() => ({}));
      throw new Error(errJson.error?.message || `HTTP ${res.status}`);
    }

    const data = await res.json();
    const replyText = data.candidates?.[0]?.content?.parts?.[0]?.text;
    if (!replyText) throw new Error("Yapay zekadan yanıt alınamadı.");
    return replyText;
  };

  try {
    return await tryModel(PRIMARY_MODEL);
  } catch (err) {
    console.warn(`generateTeacherReport ${PRIMARY_MODEL} hatası, ${FALLBACK_MODEL} deneniyor...`, err);
    return await tryModel(FALLBACK_MODEL);
  }
}

/**
 * Öğretmenin tüm öğrencilerini özetleyen ve yapay zekanın isimle öğrenci tanımasını sağlayan bağlam motoru
 */
export function buildTeacherAllStudentsSummary(students = [], currentStudent = null, curriculum = []) {
  if (!Array.isArray(students) || students.length === 0) {
    return currentStudent ? buildStudentContextSummary(currentStudent, curriculum) : "Sistemde henüz kayıtlı öğrenci bulunmuyor.";
  }

  let text = `--- ÖĞRETMENİN KAYITLI ÖĞRENCİ LİSTESİ VE GÜNCEL VERİLERİ ---\n`;
  if (currentStudent) {
    text += `(ŞU ANDA İNCELENEN ÖĞRENCİ: ${currentStudent.name} - ID: ${currentStudent.id})\n\n`;
  }

  students.forEach((s, idx) => {
    // Soru sayıları
    const assignments = Array.isArray(s.assignments) ? s.assignments : [];
    const completedAssignments = assignments.filter(a => a.status === 'completed').length;
    let thisWeekSolved = 0;
    assignments.forEach(a => {
      const c = parseInt(a.solvedCount, 10) || (a.status === 'completed' ? (parseInt(a.count, 10) || 0) : 0);
      thisWeekSolved += c;
    });

    const pastWeeks = Array.isArray(s.pastWeeks) ? s.pastWeeks : [];
    let pastSolved = 0;
    pastWeeks.forEach(w => { pastSolved += (parseInt(w.solvedCount, 10) || 0); });

    // Denemeler
    const exams = Array.isArray(s.exams) ? s.exams : [];
    const sortedExams = [...exams].sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));
    const recentExamsStr = sortedExams.slice(0, 3).map(e => `${e.date || ''} ${e.type || ''} ${e.name || ''} (Net: ${e.totalNet})`).join('; ');

    // Rutinler
    const routines = Array.isArray(s.routines) ? s.routines : [];
    let paragrafCount = 0;
    let problemCount = 0;
    routines.forEach(r => {
      const cnt = parseInt(r.count, 10) || 0;
      if (r.type === 'paragraf') paragrafCount += cnt;
      if (r.type === 'problem') problemCount += cnt;
    });

    text += `${idx + 1}. ÖĞRENCİ: ${s.name} (Sınıf/Alan: ${s.grade || s.class || 'Belirtilmemiş'} / ${s.field || 'Genel'})\n`;
    text += `   - Aktif Program: ${completedAssignments}/${assignments.length} görev tamamlandı, ${thisWeekSolved} soru çözüldü.\n`;
    text += `   - Arşivlerden Çözülen Soru: ${pastSolved} soru. Toplam Soru: ${thisWeekSolved + pastSolved}.\n`;
    text += `   - Rutinler: Toplam ${paragrafCount} paragraf, ${problemCount} problem sorusu.\n`;
    text += `   - Son Denemeler: ${recentExamsStr || 'Henüz deneme kaydı yok'}\n\n`;
  });

  return text;
}

/**
 * Öğretmenin AI Eğitim Danışmanı ile interaktif sohbetini yönetir.
 */
export async function sendTeacherAdvisorChat(chatHistory, { currentStudent = null, allStudents = [], curriculum = [], teacherName = 'Uzm. Psk. Dan. Hamza Metehan KILIÇ' } = {}) {
  const studentsContext = buildTeacherAllStudentsSummary(allStudents, currentStudent, curriculum);

  const systemPrompt = `Sen "Koçum Online AI Kıdemli Eğitim Danışmanı ve Koçluk Asistanı"sın.
Senin muhatabın doğrudan eğitim koçu / öğretmen: ${teacherName}.
Meslektaşınla konuşur gibi saygılı, analitik, vizyoner ve pedagojik derinliği yüksek bir dille iletişim kurarsın.

UZMANLIK ALANLARIN:
1. TÜRKİYE YÜZYILI MAARİF MODELİ:
- Beceri temelli öğretim programları, kavramsal beceriler (analiz, sentez, ilişkilendirme, problem çözme, modelleme).
- Sosyo-duygusal eğilimler (öz düzenleme, yılmazlık, akademik azim).
- Süreç odaklı, biçimlendirici (formative) ölçme ve değerlendirme ilkeleri.
2. SINAV SİSTEMLERİ VE STRATEJİLERİ:
- YKS (TYT/AYT/YDT), LGS, KPSS sınav dinamikleri.
- Zaman yönetimi, turlama taktiği, çeldirici analizi, deneme neti plato (durgunluk) evresini kırma yöntemleri.
- Doğru kaynak seçimi ve aşamalı soru bankası planlaması.
3. ÖĞRENCİ VE VELİ PSİKOLOJİSİ:
- Sınav kaygısı, tükenmişlik (burnout), erteleme davranışı, akıllı hedefleme (SMART).
- Veli-koç-öğrenci üçgeninde kriz çözümü ve motivasyon artırma.

RAPOR VE PROGRAM OLUŞTURMA TALİMATLARI:
- Öğretmen senden belirli bir öğrenci için (Örn: "Emir ile ilgili rapor oluştur", "Ali için veli bülteni hazırla", "Ayşe'ye haftalık çalışma programı çıkar") talepte bulunduğunda:
  1. Aşağıdaki öğrenci listesinden o öğrencinin ismini bul ve onun gerçek verilerini (denemeler, netler, soru sayıları, rutinler) temel al.
  2. Öğretmenin raporda olmasını istediği özel hususları (örn: "bu hafta geometriye odaklansın", "veliyle paylaşılacak", "net artışını öv") rapora eksiksiz ve ustaca yedir.
  3. Çıktıyı hemen veliye gönderilebilecek veya PDF olarak yazdırılabilecek profesyonellikte, net başlıklar ve maddeler halinde hazırla.
  4. Raporun altına kurumsal imza ekle: "${teacherName} & Koçum Online Eğitim Danışmanlığı".

KURALLAR:
- Öğretmenin sorduğu sorulara yuvarlak genel geçer laflar yerine doğrudan uygulanabilir somut pedagojik stratejiler, adım adım eylem planları ve taktikler ver.
- Matematik veya geometri anlatırken asla karmaşık LaTeX ($...$, \\widehat, \\circ) kodları kullanma; sade Türkçe matematik terimleri ve '°' simgesi kullan.
- Markdown formatını (başlıklar, kalın yazılar, maddeli listeler) profesyonelce kullan.

${studentsContext}
`;

  const contents = chatHistory.map(msg => ({
    role: msg.role === 'assistant' || msg.role === 'model' ? 'model' : 'user',
    parts: [{ text: msg.text || "..." }]
  }));

  const payload = {
    system_instruction: {
      parts: [{ text: systemPrompt }]
    },
    contents: contents,
    generationConfig: {
      temperature: 0.6,
      maxOutputTokens: 2500
    }
  };

  const tryModel = async (modelName) => {
    const url = `https://generativelanguage.googleapis.com/v1beta/models/${modelName}:generateContent?key=${GEMINI_API_KEY}`;
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      const errJson = await res.json().catch(() => ({}));
      throw new Error(errJson.error?.message || `HTTP ${res.status}`);
    }

    const data = await res.json();
    const replyText = data.candidates?.[0]?.content?.parts?.[0]?.text;
    if (!replyText) throw new Error("Yapay zekadan yanıt alınamadı.");
    return replyText;
  };

  try {
    return await tryModel(PRIMARY_MODEL);
  } catch (err) {
    console.warn(`sendTeacherAdvisorChat ${PRIMARY_MODEL} hatası, ${FALLBACK_MODEL} deneniyor...`, err);
    return await tryModel(FALLBACK_MODEL);
  }
}
